import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';

import { brandImageMap } from '../../utils/utils';

const CompaniesLogo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const selectedBrands = [
    'adani',
    'saatvik',
    'tata',
    'waaree',
    'sungrowpower',
    'luminous',
    'emmvee',
    'havells',
    'utl',
    'premierenergies',
  ];

  const brandNames = {
    adani: 'Adani',
    saatvik: 'Saatvik',
    tata: 'Tata',
    waaree: 'Waaree',
    sungrowpower: 'Sungrow Power',
    luminous: 'Luminous',
    emmvee: 'Emmvee',
    havells: 'Havells',
    utl: 'UTL',
    premierenergies: 'Premier Energies',
  };

  const brandImages = selectedBrands
    .map((brand) => brandImageMap[brand])
    .filter(Boolean);

  return (
    <Box
      sx={{
        backgroundColor: 'transparent',
        textAlign: 'center',
        position: 'relative',
        justifyContent: 'center',
        left: '50%',
        right: '50%',
        width: '100vw',
        transform: 'translateX(-50%)',
        px: isMobile ? 2 : 24,
        mt: isMobile ? 12 : 16,
        mb: isMobile ? 12 : 14,
      }}
    >
      <Grid container spacing={4} justifyContent='center'>
        {brandImages.map((brand, index) => (
          <Grid item key={index} xs={6} sm={4} md={2}>
            <Box
              component='img'
              src={brand}
              alt={`${brandNames[selectedBrands[index]]} solar panels logo`}
              sx={{
                maxHeight: 60,
                objectFit: 'contain',
                mx: 'auto',
                width: '100%',
                maxWidth: 120,
              }}
            />
          </Grid>
        ))}
      </Grid>
      <Typography variant='h5' fontWeight='bold' mt={4}>
        Brands we actively work with
      </Typography>
    </Box>
  );
};

export default CompaniesLogo;
